import { IToastProps } from '../components/Toast/Toast.types';

export const toastReducer = (
  state: { toasts: IToastProps[] },
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  action: { type: 'ADD_TOAST' | 'DELETE_TOAST'; payload: any },
) => {
  switch (action.type) {
    case 'ADD_TOAST':
      return {
        ...state,
        toasts: [...state.toasts, action.payload],
      };
    case 'DELETE_TOAST':
      const updatedToasts = state.toasts.filter(
        (toast: IToastProps) => toast.id !== action.payload,
      );
      return {
        ...state,
        toasts: updatedToasts,
      };
    default:
      throw new Error(`Unhandled action type: ${action.type}`);
  }
};
